import "../term/styles.css";

const privacyPage = () => {
  return (
    <div class="about-section">
      <h1>Kebijakan Privasi DiaryMuslim</h1>
      <p>
        Bismillahirahmanirrahim, Selamat Datang di Layanan Aplikasi Diary Muslim
      </p>
      <p>
        Alhamdulillah, Segala puji hanya milik Allah SWT dan Terima kasih atas
        dukungan Anda terhadap Layanan Aplikasi Diary Muslim (“Layanan”). Kami
        mencoba mambangun Layanan yang bisa bermanfaat sepenuhnya untuk saudara
        muslim dengan cara menghadirkan pengalaman dan fitur yang sesuai dengan
        kebutuhan umat. Kebijakan Privasi ini bertujuan untuk menjelaskan
        bagaimana privasi Anda dilindungi saat kami mengumpulkan, mengolah,
        mengungkapkan dan menggunakan informasi pribadi Anda.
      </p>
      <span class="span-bold">1. Privasi Anda penting bagi kami</span>
      <p>
        Diary Muslim (“Kami”) berkomitmen untuk melindungi privasi para pengguna
        Layanan Aplikasi (“Anda”).
      </p>
      <p>
        Layanan Diary Muslim di terbitkan oleh PT Diary Muslim Infomedia yang
        beralamat di Patra Jasa Building Office Tower 17th FL room 17 GATOT
        SUBROTO KAV. 32 -34, Kuningan Timur -Setiabudi, Jakarta Selatan,
        Provinsi DKI Jakarta, 12950, dimana PT Diary Muslim Infomedia juga
        bertindak sebagai pihak yang melakukan pengendalian data sehubungan
        dengan pengolahan informasi pribadi Anda.
      </p>
      <p>
        Kebijakan Privasi ini (“Kebijakan”) menjelaskan bagaimana informasi Anda
        dikumpulkan, diolah, diungkapkan dan digunakan oleh Diary Muslim ketika
        Anda menggunakan Layanan Kami sediakan.
      </p>
      <span class="span-bold">2. Peraturan yang Berlaku</span>
      <p>
        Kebijakan ini dibuat berdasarkan Peraturan Perlindungan Data Umum Uni
        Eropa (European Union’s General Data Protection Regulation) tanggal 27
        April 2016 (“GDPR”), Undang-Undang Privasi Konsumen California
        (California Consumer Privacy Act) (“CCPA”), dan Undang-Undang Nomor 11
        Tahun 2008 tentang Informasi dan Transaksi Elektronik (ITE) sebagaimana
        telah diubah dengan Undang-Undang Nomor 19 Tahun 2016 serta Peraturan
        Menteri Kominfo No. 20 Tahun 2016 tentang Perlindungan Data Pribadi
        dalam Sistem Elektronik (PM 20/2016) (selanjutnya disebut “Peraturan
        yang Berlaku”).
      </p>
      <p>
        Dalam Kebijakan ini, “informasi pribadi” adalah informasi yang dianggap
        sebagai “data pribadi” atau “informasi pribadi” (atau yang setara
        dengannya) yang diatur berdasarkan Peraturan yang berlaku dan informasi
        tersebut juga dapat mencakup informasi yang Anda berikan kepada kami
        pada saat Anda menggunakan Layanan Kami yang terkait.
      </p>
      <p>
        Pada saat Anda menggunakan Layanan Kami dan dengan tunduk pada Peraturan
        yang Berlaku, Anda telah menyetujui cara kami mengumpulkan, mengolah,
        mengungkapkan dan menggunakan informasi pribadi Anda. Apabila Peraturan
        yang Berlaku mensyaratkan persetujuan Anda diperoleh dengan cara lain,
        persetujuan Anda akan diperoleh berdasarkan ketentuan Peraturan yang
        Berlaku tersebut
      </p>
      <p>
        Anda dapat menarik kembali persetujuan Anda kapan pun dan atas alasan
        apa pun dengan mengirimkan e-mail kepada kami melalui
        contact@diarymuslim.com . Namun, apabila Anda menarik kembali
        persetujuan Anda, ada kemungkinan beberapa fitur tidak dapat berfungsi
        dengan baik seperti yang akan dijelaskan lebih detail di bawah.
      </p>
      <span class="span-bold">3. Informasi Pribadi yang Kami Kumpulkan</span>
      <p>
        Dengan memiliki akun Diary Muslim, kami dapat mengumpulkan, mengolah,
        mengungkapkan dan menggunakan jenis-jenis informasi pribadi yang Anda
        sediakan kepada kami sebagaimana disebutkan di bawah ini saat Anda
        menggunakan Layanan Aplikasi, yang termasuk namun tidak terbatas pada:
      </p>
      <ol>
        <li value="1" class="menu-item">
          Informasi yang Anda unggah atau masukkan pada Layanan Kami seperti
          nama, tanggal lahir, alamat e- mail , jenis kelamin, profesi, foto
          profil dan kota atau negara.
        </li>
        <li class="menu-item">
          Aktivitas Anda sebagai pengguna, seperti, pencarian Anda dalam fitur
          Al-Quran atau ayat-ayat Al- Quran yang Anda tandai Baca dan dengarkan
          murottal Al-Quran serta favorit ayat atau surat harian serta postingan
          yang anda bagikan.
        </li>
        <li class="menu-item">
          Perubahan-perubahan yang Anda buat terhadap pengaturan Anda.
        </li>
        <li class="menu-item">
          Informasi pribadi yang Anda berikan kepada situs milik pihak ketiga,
          termasuk namun tidak terbatas pada Facebook, Apple atau akun Google,
          pada saat Anda menggunakan situs-situs tersebut untuk melakukan
          pendaftaran atau masuk (login) pada akun Diary Muslim Anda.
        </li>
      </ol>
      <p>
        Ketika Anda memiliki akun Diary Muslim, kami dapat mengumpulkan,
        mengolah, mengungkapkan dan menggunakan jenis-jenis informasi pribadi
        sehubungan dengan perangkat dan pengaturan Layanan Kami, yang termasuk
        namun tidak terbatas pada:
      </p>
      <ol>
        <li value="1" class="menu-item">
          <b>Informasi perangkat:</b> produsen yang memproduksi perangkat,
          model, sistem operasi dan versi dari sistem operasi, serta versi
          Aplikasi.
        </li>
        <li class="menu-item">
          <b>Aktivitas Layanan :</b> Tanggal instalasi Layanan aplikasi, tanggal
          terakhir Layanan aplikasi digunakan, kota, negara, alamat IP, zona
          waktu, bahasa nama dan negara operator seluler Anda, durasi sesi,
          informasi mengenai penggunaan fitur.
        </li>
        <li class="menu-item">
          <b>Informasi geolokasi :</b> Seperti ketika Anda selesai membaca atau
          mendengarkan murottal Al-Quran dan mem-posting dalam halaman homefeed
          hal ini untuk menunjukan dimana saja dan kapan saja Anda bisa membaca
          atau mendengarkan murottal Al-Quran dengan Layanan Kami ini, Informasi
          geolokasi tersebut akan selalu disimpan dalam perangkat Anda.
          Informasi tersebut dikirimkan ke server kami hanya pada saat Anda
          menggunakan fitur tersebut, namun kami tidak akan pernah menyimpan
          informasi tersebut.
        </li>
        <li class="menu-item">
          <b>Analitik:</b> Merupakan informasi yang diberikan kepada kami oleh
          penyedia layanan analitik kami – yaitu Google Firebase, Google
          Analytics for Firebase dan Google Firebase Crashlytics
        </li>
      </ol>
      <span class="span-bold">
        4. Bagaimana kami menggunakan informasi pribadi Anda?
      </span>
      <p>
        Diary Muslim dapat mengumpulkan, mengolah, dan menggunakan informasi
        Anda sebagaimana diperlukan untuk melaksanakan hubungan kesepakatan kami
        dengan Anda, terutama untuk:
      </p>
      <ol>
        <li value="1" class="menu-item">
          Memungkinkan Anda untuk mengakses (login) dan menggunakan Layanan
          aplikasi yang tersedia dari perangkat manapun dengan Akun Anda
        </li>
        <li class="menu-item">
          Melakukan sinkronisasi pengaturan Aplikasi Anda, misalnya terkait Akun
          Profil Anda, informasi aktivitas terakhir baca dan dengarkan murottal
          ayat Al-Quran dan informasi lokasi terakhir Anda, pada seluruh
          perangkat yang terhubung dengan akun Anda.
        </li>
        <li class="menu-item">
          Menginformasikan dan memberikan update terbaru kepada Anda mengenai
          perubahan-perubahan terhadap Layanan aplikasi, antara lain pembaharuan
          perangkat lunak, layanan-layanan, dan untuk memberikan tanggapan
          terhadap pertanyaan-pertanyaan Anda.
        </li>
      </ol>
      <p>
        Diary Muslim dapat juga, baik sendiri maupun dengan bantuan software
        development kit (SDK) milik pihak ketiga, mengumpulkan, mengolah,
        mengungkapkan dan menggunakan informasi Anda guna kepentingan kami,
        terutama untuk:
      </p>
      <ol>
        <li value="1" class="menu-item">
          Melaksanakan riset, analisis, dan kegiatan pengembangan, untuk
          mengamati bagaimana Anda menggunakan Layanan aplikasi, untuk
          meningkatkan pengalaman Anda sebagai pengguna, dan meningkatkan
          Layanan kami
        </li>
        <li class="menu-item">
          Menyesuaikan pengalaman Anda (user experience), seperti, menampilkan
          konten dan pemberitahuan yang sesuai dengan minat dan preferensi Anda.
        </li>
      </ol>
      <p>
        Terlepas dari hal-hal di atas, beberapa peraturan tertentu mungkin
        mewajibkan kami untuk memperoleh persetujuan Anda terlebih dahulu untuk
        beberapa tujuan yang disebutkan di atas.
      </p>
      <p>
        Terakhir, Diary Muslim juga dapat mengumpulkan, mengolah, mengungkapkan
        dan menggunakan informasi Anda untuk mematuhi ketentuan hukum yang
        relevan yang menjadi kewajiban hukum kami, dan atau untuk tujuan lain
        dimana Diary Muslim wajib memberitahukan kepada pihak-pihak yang
        berwenang sesuai dengan aturan hukum yang berlaku
      </p>
      <p>
        <b>Login Menggunakan Google</b>
        <br />
        Layanan kami menggunakan Firebase Authentication untuk "Sign In",
        sehingga kami dapat mengidentifikasikan bookmark Anda saat menggunakan
        fitur export/import bookmark ke atau dari Cloud kami. Jadi secara tidak
        langsung alamat Gmail Anda akan disimpan ke dashboard Firebase kami dan
        database Cloud kami saat Anda menggunakan fitur tersebut.
      </p>
      <p>
        Firebase adalah salah satu produk Google, dan Google tidak akan
        mengizinkan untuk mengetahui kata sandi (password) Anda dengan cara apa
        pun, jadi tidak mungkin kami mengumpulkan kata sandi Gmail Anda. Kami
        hanya mengumpulkan alamat Gmail saja untuk mempermudah identifikasi
        Bookmark milik Anda. Jadi Anda tidak perlu khawatir kehilangan akun
        Gmail Anda, dan juga kami tidak akan membagikan alamat Gmail Anda kepada
        siapa pun untuk tujuan apa pun.
      </p>
      <p>
        <b>Login Menggunakan Facebook</b>
        <br />
        Login di aplikasi Diary Muslim dapat dilakukan menggunakan akun
        facebook. Jadi secara tidak langsung akun facebook Anda disimpan di
        database kami, data facebook yang tersimpan di kami diantaranya, nama,
        foto profil, dan email. Kami tidak akan membagikan akun facebook Anda
        kepada siapa pun. Facebook tidak akan mengizinkan untuk mengetahui kata
        sandi (password) Anda dengan cara apa pun, jadi tidak mungkin kami
        mengumpulkan kata sandi facebook Anda.
      </p>
      <span class="span-bold">
        5. Kepada siapa informasi Anda dapat dibagikan?
      </span>
      <p>
        Kami dapat membagikan informasi Anda kepada (i) penyedia layanan kami,
        seperti penyedia layanan hosting, misalkan, Google, (ii) otoritas
        terkait sebagaimana diwajibkan oleh hukum, putusan pengadilan atau
        administratif, dan (iii) penasihat dan konsultan hukum kami, jika
        diperlukan.
      </p>
      <p>
        Pada saat Anda menggunakan fitur posting, komentar, informasi nama login
        Anda dapat terlihat oleh pengguna lain.
      </p>
      <p>
        IP Geolocation API dari Big Data cloud untuk menunjukan estimasi lokasi
        anda ketika sedang membaca atau mendengarkan murottal Al-Quran. API ini
        tunduk pada Persyaratan Layanan dan Kebijakan Privasi Big Data Cloud
        yang dapat diperbaharui dari waktu ke waktu
      </p>
      <span class="span-bold">
        6. Berapa lama kami menyimpan informasi Anda?
      </span>
      <p>
        Ketika Anda melakukan pendaftaran akun pada Layanan kami, informasi akun
        Anda termasuk pengaturan Aplikasi dan preferensi Anda disimpan selama
        Anda menggunakan Layanan kami, dan diarsipkan untuk jangka waktu yang
        terbatas.
      </p>
      <p>
        Apabila akun Anda tidak aktif selama lima tahun, kami akan mengirimkan
        notifikasi untuk menanyakan apakah Anda ingin mempertahankan akun Anda;
        apabila Anda tidak memberikan tanggapan selama 14 hari, kami akan
        menghapus informasi pribadi Anda pada Layanan kami, kecuali apabila
        ketentuan hukum yang berlaku mewajibkan kami untuk menyimpan atau
        mempertahankan informasi tersebut, dengan ketentuan bahwa setelah
        periode tersebut, data tersebut dapat diarsipkan untuk tujuan tertentu
        dan terutama apabila terjadi potensi sengketa.
      </p>
      <span class="span-bold">
        7. Bagaimana kami melindungi informasi Anda?
      </span>
      <p>
        Kami memiliki serangkaian prosedur keamanan untuk melindungi dan
        mencegah kehilangan atau penyalahgunaan informasi pribadi Anda. Kami
        melakukan sebaik mungkin untuk melindungi data pribadi Anda. Dalam hal
        terjadinya kegagalan perlindungan data pribadi Anda, Kami akan
        memberitahukan secara tertulis kepada Anda sesuai dengan peraturan yang
        berlaku.
      </p>
      <span class="span-bold">Fitur Pengaturan Privasi Kontrol Anda</span>
      <p>
        Layanan Diary Muslim memberikan beberapa fitur dalam pengelolaan privasi
        anda dan pengaturan ketika membagikan aktivitas Anda. Secara umum
        privasi kontrol terletak di halaman pengaturan profil, tapi secara
        khusus fitur tersebut terdapat juga pilihan ketika Anda akan posting
        aktivitas seperti membaca atau mendengarkan murottal Al-Quran
      </p>
      <span class="span-bold">Fitur Permintaan Penghapusan Akun Anda</span>
      <p>
        Anda bisa melakukan penghapusan Akun secara mandiri menggunakan fitur
        “Request Delete Account”.
      </p>
      <p>
        Segera, Setelah Anda membuat permintaan penghapusan, kami menghapus data
        pribadi Anda secara permanen dan tidak dapat diubah dari sistem kami,
        termasuk cadangan. Setelah dihapus, data Anda, termasuk akun, aktivitas,
        dan tempat Anda di papan peringkat tidak dapat dipulihkan. Setelah akun
        Anda dihapus, mungkin diperlukan waktu hingga 90 hari untuk menghapus
        informasi pribadi dan log sistem Anda dari sistem kami. Selain itu, kami
        dapat menyimpan informasi jika permintaan penghapusan dibuat untuk
        mematuhi hukum dan mengambil tindakan lain yang diizinkan oleh hukum.
      </p>
      <p>
        Perhatikan bahwa konten yang telah Anda bagikan dengan orang lain,
        seperti komentar, atau yang telah disalin orang lain juga dapat tetap
        terlihat setelah Anda menghapus akun atau menghapus informasi tertentu
        dari profil Anda sendiri. Profil publik Anda mungkin ditampilkan di
        hasil mesin telusur hingga mesin telusur menyegarkan cache-nya.
      </p>
      <p>
        Layanan Diary Muslim juga memberi Anda pilihan untuk menghapus aktivitas
        individu yang telah Anda posting tanpa menghapus akun Anda. Setelah
        dihapus, aktivitas tersebut mungkin tetap ada di sistem Diary Muslim
        sampai Anda menghapus akun Anda.
      </p>
      <span class="span-bold">
        8. Apa saja hak-hak saya sehubungan dengan pengolahan informasi?
      </span>
      <p>
        Sesuai dengan Peraturan yang Berlaku, Anda memiliki hak untuk mengakses,
        memperbaiki, menghapus, dan, apabila dimungkinkan, meminta portabilitas
        data pribadi Anda dimana Anda dapat meminta pengalihan data pribadi
        tersebut ke perangkat Anda yang lain kapanpun Anda menghendakinya.
      </p>
      <p>
        Anda juga dapat meminta kami untuk membatasi, atau, dalam
        situasi-situasi tertentu, mengajukan keberatan terhadap pengolahan
        informasi Anda.
      </p>
      <p>
        Apabila Anda berkenan, Anda dapat memberi instruksi kepada kami di awal
        terkait bagaimana Anda ingin kami mengelola informasi pribadi Anda pada
        saat Anda meninggal dunia.
      </p>
      <p>
        Terkait manajemen perlindungan data pribadi Anda, Anda dapat kapan pun
        menghubungi kami{" "}
        <a href="mailto:contact@diarymuslim.com">contact@diarymuslim.com</a>
      </p>
      <p>
        Anda juga dapat mengajukan keluhan kepada otoritas perlindungan data
        yang kompeten di negara Anda kapanpun Anda merasa bahwa pengolahan
        informasi pribadi Anda tidak sesuai dengan Peraturan yang Berlaku.
      </p>
      <span class="span-bold">9. Perubahan terhadap Kebijakan ini</span>
      <p>
        Apabila kami mengubah Kebijakan ini, kami akan memberitahu Anda mengenai
        perubahan-perubahan yang kami lakukan melalui Aplikasi atau e-mail. Anda
        dapat menolak perubahan-perubahan yang dibuat namun Anda mungkin tidak
        dapat lagi menggunakan beberapa atau keseluruhan fitur pada Layanan
        aplikasi.
      </p>
      <span class="span-bold">10. Kontak</span>
      <p>
        Apabila Anda memiliki pertanyaan mengenai Kebijakan ini atau penggunaan
        informasi pribadi Anda, mohon hubungi kami melalui:{" "}
        <a href="mailto:contact@diarymuslim.com">contact@diarymuslim.com</a>
      </p>
      <br />
      <span class="span-bold mt-10">Pembaruan Terakhir: 13 Maret 2022</span>
      <p>
        <span class="span-bold">Hak Cipta PT Diary Muslim Infomedia</span>
      </p>
    </div>
  );
};

export default privacyPage;
